import { Box, Skeleton, Text } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
export const PaymentSelection = Box.withConfig({
  marginTop: '$4',
  paddingBottom: '$8',
});

export const DisclaimerWrapper = Text.withConfig({
  color: primitive.$greyOne,
  fontFamily: 'body',
  fontSize: 'xs',
  marginTop: 0,
  marginRight: 0,
  marginBottom: '$4',
  marginLeft: 0,
  paddingX: '$1',
  paddingY: 0,
  textAlign: 'center',
});

export const CartPriceTooLow = Box.withConfig({
  _text: {
    textAlign: 'center',
    color: getDesignToken('alert-warning-background'),
  },
  padding: '$2',
  borderWidth: 0,
  borderColor: getDesignToken('alert-warning-background'),
  margin: 0,
});

export const ErrorContainer = Box.withConfig({
  marginTop: '$4',
  backgroundColor: '#fae7ea',

  _text: {
    textAlign: 'center',
  },
});

export const ErrorMessage = Text.withConfig({
  marginX: '$8',
  marginY: 0,
  paddingX: 0,
  paddingY: '11px',
  color: primitive.$fieryRed,
});

export const SignUpToContinueDisclaimer = Text.withConfig({
  color: primitive.$greyOne,
  fontSize: 'sm',
  fontWeight: primitive.$fontWeightNormal,
  textAlign: 'center',
  marginBottom: '$8',
});

export const WarningContainer = Box.withConfig({
  paddingTop: '$6',
  paddingBottom: '$3',
  paddingX: 0,
  marginRight: '$3',
});

export const SkeletonStyled = Skeleton.withConfig({
  testID: 'currency-line-skeleton',
  height: '$4',
  width: '120px',
  alignSelf: 'center',
  color: primitive.$greyFour,
  borderRadius: 'full',
  mb: '$3',
});

export const TotalContainer = Box.withConfig({
  mb: '$4',
  flexDirection: 'row',
  focusable: true,
});

export const IconContainer = Box.withConfig({
  ml: '$1',
});
